import React from "react";
import { FaRupeeSign, FaChartLine, FaBriefcase, FaFileInvoiceDollar, FaCar, FaMotorcycle } from "react-icons/fa";

interface ServicesProps {
  sectionRef: (el: HTMLElement | null) => void;
}

const Services: React.FC<ServicesProps> = ({ sectionRef }) => {
  return (
    <section id="services" ref={sectionRef} className="w-full py-20 md:py-24 bg-transparent text-text-primary relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
          <div className="space-y-4">
            <div className="text-primary font-bold text-sm uppercase tracking-wider bg-primary/10 inline-block px-4 py-1.5 rounded-full">Our Core Offerings</div>
            <h2 className="text-4xl md:text-5xl font-black tracking-tighter leading-[0.9] text-text-primary">
              Comprehensive <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">Loan Services</span>
            </h2>
          </div>
          <div className="text-text-secondary font-medium text-lg max-w-[400px]">
            Tailored loan products designed to fuel growth, empower individuals, and support business excellence.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Instant Personal Cash",
              icon: <FaRupeeSign />,
              desc: "Get fast access to extra funds for medical needs, travel, or emergencies with zero long-term stress."
            },
            {
              title: "Credit Upgrade Program",
              icon: <FaChartLine />,
              desc: "Unlock better financial opportunities by building or repairing your credit score through our structured plans."
            },
            {
              title: "Business Acceleration",
              icon: <FaBriefcase />,
              desc: "Fuel your enterprise's growth with quick working capital designed for the modern digital economy."
            },
            {
              title: "Tax-Powered Capital",
              icon: <FaFileInvoiceDollar />,
              desc: "Leverage your GST returns to secure fast, collateral-free funding to maintain uninterrupted operations."
            },
            {
              title: "Premium Car Financing",
              icon: <FaCar />,
              desc: "Drive home your dream vehicle with competitive rates and flexible tenures tailored for your budget."
            },
            {
              title: "Swift Two-Wheeler Loans",
              icon: <FaMotorcycle />,
              desc: "Enjoy the freedom of movement with our quick-approval bike loans, with financing up to 100%."
            }
          ].map((service, i) => (
             <div key={i} className="bg-white p-10 rounded-[2rem] border border-gray-100 shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 group">
              <div className="text-5xl text-primary mb-8 group-hover:scale-110 group-hover:text-secondary transition-transform origin-left">{service.icon}</div>
              <h3 className="text-2xl font-black mb-4 text-text-primary tracking-tight">{service.title}</h3>
              <div className="w-12 h-1 bg-primary/20 mb-6 group-hover:bg-primary group-hover:w-20 transition-all rounded-full" />
              <p className="text-text-secondary leading-relaxed font-medium">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
